/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Checkbox,
  checkboxClasses,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  useTheme,
} from '@mui/material';
import { Controller } from 'react-hook-form';

export type MuiCheckboxProps = CheckboxProps & {
  name: string;
  label: string;
  control: any;
};

export function MuiCheckbox({
  name,
  label,
  control,
  ...CheckboxProps
}: MuiCheckboxProps) {
  const theme = useTheme();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl
          sx={{
            minWidth: '400px',
            maxWidth: '400px',
            display: 'flex',
            alignContent: 'center',
            height: '60px',
            minHeight: '60px',
          }}
          variant="outlined"
        >
          <FormControlLabel
            label={label}
            labelPlacement="start"
            control={
              <Checkbox
                {...CheckboxProps}
                size="medium"
                onChange={onChange}
                checked={value}
                sx={{
                  display: 'flex',

                  alignContent: 'center',
                  [`&, &.${checkboxClasses.checked}`]: {
                    color: theme.palette.primary.main,
                  },
                  [`&, &.${checkboxClasses.colorSecondary}`]: {
                    color: theme.palette.neutral.veryDarkGrey,
                  },
                }}
              />
            }
            sx={{
              height: '100%',
              border: error
                ? '1px solid #bf1319'
                : `1px solid ${theme.palette.neutral.midGrey}`,
              color: error ? '#bf1319' : theme.palette.text.primary,
              justifyContent: 'space-between',
              borderRadius: 2,
              paddingLeft: 2,
              display: 'flex',
              margin: 0,
            }}
            slotProps={{
              typography: {
                sx: {
                  fontSize: label.length >= 72 ? '15px' : '16px',
                  lineHeight: 1.2,
                },
              },
            }}
          />
        </FormControl>
      )}
    />
  );
}
